export function getPageScrollElement() {
    if (typeof document === "undefined") return null
    return document.querySelector(".page-content")
}

export function scrollPageToTop(behavior = "smooth") {
    const scrollElement = getPageScrollElement()
    if (scrollElement && typeof scrollElement.scrollTo === "function") {
        scrollElement.scrollTo({ top: 0, behavior })
        return
    }
    window.scrollTo({ top: 0, behavior })
}
